import React from 'react';

const SuspectIcon = () => {
  const blockUIStyles = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999999999999,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // You can adjust the background color and opacity
  };

  const imageStyles = {
    width: '250px',
    height: '250px',
  };

  return (
    <div style={blockUIStyles}>
      <img
        src={`${window.location.origin}/images/mark-as-suspect-icon.png`}
        alt="Suspect"
        style={imageStyles}
      />
    </div>
  );
};

export default SuspectIcon;
